// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SetOnePageCheckoutProductLisOverlayParameter } from "@store/Framework/Store/Starter/Components/OnePageCheckoutProductListOverlay/Handlers/SetOnePageCheckoutProductListOverlayIsOpen";
import OnePageCheckoutProductListOverlayState from "@store/Framework/Store/Starter/Components/OnePageCheckoutProductListOverlay/OnePageCheckoutProductListOverlayState";
import { Draft } from "immer";

const initialState: OnePageCheckoutProductListOverlayState = {
    isOpen: false,
};

const actions = {
    "Starter/Components/OnePageCheckoutProductListOverlay/SetOnePageCheckoutProductListOverlayIsOpen": (
        draft: Draft<OnePageCheckoutProductListOverlayState>,
        action: { parameter: SetOnePageCheckoutProductLisOverlayParameter },
    ) => {
        draft.isOpen = action.parameter.isOpen;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type OnePageCheckoutProductListOverlayActions = Parameters<typeof reducer>[1];
export default reducer;
